// Dispara la descarga de un blob en el navegador vía <a download> efímero
// (mismo patrón que la descarga de Data ERP). Función pura de DOM: sin
// notificaciones ni estado — el caller maneja toasts y loading.
export function downloadBlob(data, filename) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

// Descarga una URL ya lista (p. ej. la prefirmada de S3 del export del
// reporte): mismo <a download> efímero, sin pasar el contenido por axios.
// El nombre lo fija el Content-Disposition de la respuesta cuando la URL es
// de otro origen; `filename` cubre el caso same-origin (storage local).
export function downloadUrl(url, filename) {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || "");
    link.setAttribute("rel", "noopener");
    document.body.appendChild(link);
    link.click();
    link.remove();
}
